import { LockStates } from '~/types/adamTypes';
import { NomadDB } from '~/db/NomadDB';
import { getServices } from '~/db/services';

export const getCategoryAncestors = async (
  $db: NomadDB,
  baseCategory: CategorySchema,
  libraryBookId: string
): Promise<CategorySchema[]> => {
  const { categoriesService } = getServices($db);

  const breadcrumb = baseCategory.breadcrumb || [];

  let ancestorIds: string[] = breadcrumb.reverse();

  let results = await categoriesService.findByIdsAndLibraryBookId(
    ancestorIds,
    libraryBookId
  );

  results = results.filter(
    (ancestor) => ancestor.contentType !== ContentTypes.Menu
  );

  const mAncestors = new Map<string, CategorySchema>();

  results.forEach((anc) => mAncestors.set(anc.id, anc));

  const injectedAncestor = results.find((ancestor) => ancestor.injected);

  if (injectedAncestor) {
    const injectedAncestorBreadcrumb = injectedAncestor?.breadcrumb || [];
    const ancestorInjectedIds: string[] = injectedAncestorBreadcrumb.reverse();
    let injectedResults = [];
    injectedResults = await categoriesService.findByIdsAndLibraryBookId(
      ancestorInjectedIds,
      libraryBookId
    );
    injectedResults = injectedResults.filter(
      (ancestor) => ancestor.contentType !== ContentTypes.Menu
    );
    const injectedIndex = ancestorIds.findIndex(
      (item) => item === injectedAncestor.id
    );
    ancestorIds = ancestorIds.slice(0, injectedIndex);
    ancestorIds = [...ancestorIds, ...ancestorInjectedIds];

    injectedResults.forEach((anc) => mAncestors.set(anc.id, anc));
  }

  let ancestors = [];

  ancestorIds.forEach((id) => {
    if (mAncestors.has(id)) {
      ancestors.push(mAncestors.get(id));
    }
  });

  ancestors = [baseCategory, ...ancestors];

  return ancestors;
};

export const getCategoryAncestorsLockState = (
  ancestors: CategorySchema[]
): LockStates => {
  const ancestor = ancestors.find((cat) => {
    return cat.lockState !== 'default';
  });
  return ancestor?.lockState || LockStates.Default;
};
